import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import axios from '../helpers/Axios';

const UserContext = createContext(undefined);

export const UserProvider = ({ children }) => {
  const { user } = useAuth();
  const [userDetails, setUserDetails] = useState(null);
  const [keycloakId, setKeycloakId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const isLoggedIn = !!userDetails;

  useEffect(() => {
    if (user?.profile?.sub) {
      setKeycloakId(user.profile.sub);
      // fetchUserDetails(user.profile.sub);
    }
  }, [user]);

  // const fetchUserDetails = async (id) => {
  //   setIsLoading(true);
  //   // const token = auth.user?.access_token;
  //   // const refreshToken = auth.user?.refresh_token;
  //   try {
  //     const response = await axios.post(`/authentication/esecure/token/`, {
  //       keycloak_id: id,
  //       access_token: user?.access_token
  //     });
  //     setUserDetails(response.data);
  //   } catch (error) {
  //     console.error('Failed to fetch user details:', error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <UserContext.Provider value={{ 
      userDetails,
       keycloakId, 
      //  fetchUserDetails, 
       isLoading, 
       isLoggedIn 
     }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
